import type { BadgeProps } from '@chakra-ui/react'
import { Badge } from '@chakra-ui/react'

export const BadgeStep = ({ children, ...rest }: BadgeProps) => {
  return (
    <Badge
      sx={{
        w: 8,
        h: 8,
        display: 'inline-grid',
        placeItems: 'center',
        fontWeight: 'medium',
        flexShrink: 0,
      }}
      variant="solid"
      bg="badge-bg"
      {...rest}
    >
      {children}
    </Badge>
  )
}
